import { LoadState } from "../../../constants/enums";

export interface IGLAgingReportItem {
  gl_account_code: string;
  gl_account_name: string;
  "0_30": string;
  "31_60": string;
  "61_90": string;
  over_90: string;
  raw_net_balance: string;
}

export interface IGLAgingReportState {
  list: IGLAgingReportItem[];
  loading: LoadState;
  totalRecords: number;
}

export const initialGLAgingReportState: IGLAgingReportState = {
  list: [],
  loading: LoadState.NotLoaded,
  totalRecords: 0,
};
